import React, { useCallback, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout } from "../Layouts";

function AdditionalTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
        props.additonalFormLookupsLoad(formRefs);
    }, []);


    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='63C69755-063D-47E8-8D99-F2E3BAD3FD7D'
                layoutName='CarrierAdditionalTab'
                defaultFormSchema={AdditionalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleCodesFormLoad}
            />
        </div>

    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(AdditionalTab);
